// export const dynamic = 'force-dynamic'
import React from 'react'
// import Products from '@/data/products0.json'
import { Metadata } from 'next';
// import cl from '@/utils/console/cl';
import ProductsByCategory from '@/components/Products/ProductsByCategory';
export const metadata: Metadata = {
  title: 'Products | TEX EXCELLENCE LIMITED',
  description: 'Products | TEX EXCELLENCE LIMITED',
}

export default function ProductPageRoute({ params }: { params: { product_category: string } }) {
  // cl("Products", Products);
  
  return (

    <ProductsByCategory params={params} />

  )
}

// export default ProductPageRoute
